import { Image, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PromosBanner.css';
import promoSvg from './assets/promo.svg';

export interface IPromosBannerProps {
  CallButton: React.ComponentType;
  text: string;
}

export const PromosBanner = ({ CallButton, text }: IPromosBannerProps) => {
  return (
    <div className={styles['banner']}>
      <div className={styles['image-wrapper']}>
        <Image src={promoSvg} objectFit="contain" height="80px" display="block" />
      </div>
      <div className={styles['text']}>
        <UIText1>{text}</UIText1>
      </div>
      <div className={styles['call-button-wrapper']}>
        <CallButton />
      </div>
    </div>
  );
};
